import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCallback, useMemo } from 'react';
import { Fade } from 'react-awesome-reveal';
import classes from 'classnames';
import * as R from 'Router/routes';
import { Button, Card, Typography } from 'components';
import { useBanksQuery } from 'hooks/webapi';
import PaymentDetails from 'components/PaymentDetails/PaymentDetails';
import H1 from 'components/H/H1';
import styles from './Manual.module.scss';

export default function Manual() {
  const { t } = useTranslation('identification_manual');
  const { data: banksList, isLoading } = useBanksQuery();
  const navigate = useNavigate();

  const goToNextStep = useCallback(() => {
    navigate(R.PENDING);
  }, [navigate]);

  const selectedBank = useMemo(() => {
    if (!banksList) return;

    return {
      title: banksList.templates?.[0]?.bankName,
      content: <PaymentDetails value={banksList.templates?.[0]} />,
    };
  }, [banksList]);

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <div className={classes(styles['box-wrapper'], styles.titleWrapper)}>
        <H1>{t('title')}</H1>
        <Typography
          className={styles['information-text']}
          dataTest="manual-message"
        >
          {t('message')}
        </Typography>
      </div>

      <div className={classes(styles['box-wrapper'], styles.cardWrapper)}>
        <Card className={styles.card} dataTest="manual-card">
          <Typography size="m" kind="h2" className={styles['space-after']}>
            {t('choose_bank')}
          </Typography>
          <div className={styles['space-after']}>
            <div className={styles.tab} key={selectedBank?.title}>
              <div className={styles.container}>
                <Fade>
                  <div
                    className={styles.content}
                    data-test="togglelist-item-content"
                  >
                    {selectedBank?.content}
                  </div>
                </Fade>
              </div>
            </div>
          </div>
          <Button
            className={styles.button}
            onClick={goToNextStep}
            size="l"
            dataTest="approve_btn_manual"
            disabled={isLoading}
          >
            {t('confirm')}
          </Button>
        </Card>
      </div>
    </>
  );
}
